import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M956.952,0 C594.552,0 299.952,294.6 299.952,656.88 C299.952,837.48 380.232,1004.76 545.352,1168.44 C785.112,1406.4 896.952,1626.12 896.952,1860 L896.952,1920 L1016.952,1920 L1016.952,1860 C1016.952,1627.2 1127.232,1413.84 1374.552,1168.56 C1539.672,1004.76 1619.952,837.48 1619.952,656.88 C1619.952,294.6 1325.352,0 956.952,0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMarkerSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMarkerSolid, _Component);

  var _super = _createSuper(IconMarkerSolid);

  function IconMarkerSolid() {
    _classCallCheck(this, IconMarkerSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMarkerSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMarker",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMarkerSolid.displayName = "IconMarkerSolid";
  return IconMarkerSolid;
}(Component);

IconMarkerSolid.glyphName = 'marker';
IconMarkerSolid.variant = 'Solid';
IconMarkerSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMarkerSolid;
export { IconMarkerSolid };